import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";

import {
  ALLOWED_DOCUMENT_ACCEPT,
  ALLOWED_DOCUMENT_EXTENSIONS,
} from "../change-request-document-groups";

@Component({
  selector: "app-cr-document-upload",
  templateUrl: "./cr-document-upload.component.html",
  styleUrls: ["./cr-document-upload.component.scss"],
})
export class CrDocumentUploadComponent {
  @Input() groupId = "";
  @Input() requiredDocsLabel = "";
  @Input() files: File[] = [];
  @Input() disabled = false;
  @Input() required = false;
  @Input() showRequiredError = false;

  @Output() filesChange = new EventEmitter<File[]>();

  @ViewChild("fileInput", { static: false })
  fileInput?: ElementRef<HTMLInputElement>;

  readonly acceptTypes = ALLOWED_DOCUMENT_ACCEPT;
  uploadError = "";

  get missingRequired(): boolean {
    return this.required && this.showRequiredError && this.files.length === 0;
  }

  /** Red highlight when upload is mandatory but no file selected yet. */
  get showRequiredHighlight(): boolean {
    return this.required && this.files.length === 0;
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const selected = input.files ? Array.from(input.files) : [];
    if (selected.length === 0) {
      return;
    }

    const invalid = selected.filter((f) => !this.isAllowedFile(f));
    if (invalid.length > 0) {
      this.uploadError = `Unsupported file type. Allowed: ${ALLOWED_DOCUMENT_EXTENSIONS.join(", ")}`;
      this.clearInput();
      return;
    }

    this.uploadError = "";
    const merged = [...this.files, ...selected];
    this.filesChange.emit(merged);
    this.clearInput();
  }

  removeFile(index: number): void {
    const next = this.files.filter((_, i) => i !== index);
    this.filesChange.emit(next);
    this.uploadError = "";
  }

  triggerBrowse(): void {
    if (this.disabled) {
      return;
    }
    this.fileInput?.nativeElement.click();
  }

  private isAllowedFile(file: File): boolean {
    const name = file.name || "";
    const dot = name.lastIndexOf(".");
    const ext =
      dot >= 0 ? name.slice(dot + 1).toLowerCase() : "";
    return (
      ext !== "" &&
      (ALLOWED_DOCUMENT_EXTENSIONS as readonly string[]).includes(ext)
    );
  }

  private clearInput(): void {
    if (this.fileInput?.nativeElement) {
      this.fileInput.nativeElement.value = "";
    }
  }
}
